<div class="modal-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <h2>Proposal description</h2>
      <button class="close-btn" (click)="onClose()" aria-label="Close modal">
        ×
      </button>
    </div>

    <div class="modal-body">
      <p class="modal-description">
        For further explanation, you can put a description or reason as to why
        the candidate meets the needs being sought.
      </p>

      <form (ngSubmit)="onSubmit()" #proposalForm="ngForm">
        <div class="form-group">
          <label for="job-select" class="form-label">Select Job</label>
          <select
            id="job-select"
            class="form-select"
            [(ngModel)]="selectedJob"
            name="job"
            required
          >
            <option value="" disabled>Job</option>
            <option *ngFor="let job of jobOptions" [value]="job">
              {{ job }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="reason-textarea" class="form-label">Reason</label>
          <textarea
            id="reason-textarea"
            class="form-textarea"
            [(ngModel)]="reason"
            name="reason"
            placeholder="Description"
            rows="4"
            required
          ></textarea>
        </div>

        <div class="modal-actions">
          <button type="button" class="btn btn-cancel" (click)="onCancel()">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-submit"
            [disabled]="!selectedJob || !reason.trim()"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
